import axios from 'axios';

// Admin/manager API for managing apps and their terms/policies/documents.
export default {
  // Apps
  getApps() {
    return axios.get('/api/v1/apps');
  },
  getApp(id) {
    return axios.get(`/api/v1/apps/${id}`);
  },
  createApp(app) {
    return axios.post('/api/v1/apps', { app });
  },
  updateApp(id, app) {
    return axios.patch(`/api/v1/apps/${id}`, { app });
  },
  deleteApp(id) {
    return axios.delete(`/api/v1/apps/${id}`);
  },

  // Documents (terms / policies / documents / manuals / guides) per app
  getDocuments(appId) {
    return axios.get(`/api/v1/apps/${appId}/app_documents`);
  },
  // `doc` is a plain object; if it carries a File under `file`, send multipart.
  createDocument(appId, doc) {
    return axios.post(`/api/v1/apps/${appId}/app_documents`, buildBody(doc), buildConfig(doc));
  },
  updateDocument(appId, id, doc) {
    return axios.patch(`/api/v1/apps/${appId}/app_documents/${id}`, buildBody(doc), buildConfig(doc));
  },
  deleteDocument(appId, id) {
    return axios.delete(`/api/v1/apps/${appId}/app_documents/${id}`);
  }
};

function hasFile(doc) {
  return doc.file instanceof File;
}

function buildBody(doc) {
  if (!hasFile(doc)) {
    return { app_document: doc };
  }
  const fd = new FormData();
  Object.entries(doc).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    fd.append(`app_document[${k}]`, v);
  });
  return fd;
}

function buildConfig(doc) {
  return hasFile(doc) ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
}
